<div class="legend">
  <div class="legend-item">
    <span class="legend-circle red"></span>
    <span class="legend-text">Entrada e Gestão de Contatos</span>
  </div>
  <div class="legend-item">
    <span class="legend-circle blue"></span>
    <span class="legend-text">Criação de Envios e Relatórios</span>
  </div>
  <div class="legend-item">
    <span class="legend-circle orange"></span>
    <span class="legend-text">Configurações e Usuários</span>
  </div>
</div>
<div class="category-grid pt-3">
  <div *ngFor="let category of categoryList.categories" class="category-col">
    <app-category [category]="category"></app-category>
  </div>
</div>
